// extracted by mini-css-extract-plugin
export default {"btn":"Btn_btn__AyGPc","primary":"Btn_primary__IlyQc","inverse":"Btn_inverse__NpUTZ","disabled":"Btn_disabled__HzKpG","square":"Btn_square__r--zB","hasIcon":"Btn_hasIcon__RFnub"};